import React, { useState } from "react";
import { toast } from "react-toastify";
import { X } from "lucide-react";
import { overrideCandidateVerification } from "../../../services/admin/api";

const OverrideDecisionModal = ({
  candidateId,
  currentStatus,
  criminalChecks,
  onClose,
  onSuccess,
}) => {
  
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    
    if (!reason.trim()) {
      toast.error("Override reason is mandatory.");
      return;
    }

    if (reason.trim().length > 500) {
      toast.error("Override reason cannot exceed 500 characters.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
      verificationStatus: "CLEAR",
      reason: reason.trim(),
    };

      const response = await overrideCandidateVerification(
        candidateId,
        payload
      );

      toast.success(
      response?.message ||
    "Verification decision overridden successfully.");

    onSuccess(response);

    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Failed to override verification decision.";

      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="override-modal-overlay">
      <div className="override-modal">
        <div className="override-modal-header">
          <h2>Override Verification Decision</h2>

          <button
            type="button"
            className="override-close-btn"
            onClick={onClose}
            disabled={loading}
          >
            <X size={20} />
          </button>
        </div>

        <div className="override-modal-body">

          <div className="override-info">
            <div>
              <span className="override-label">Candidate ID</span>
              <span className="override-value">{candidateId}</span>
            </div>

            <div>
              <span className="override-label">Current Result</span>
              <span className="override-current-status">
         {criminalChecks?.length > 0
           ? criminalChecks
           .map(
            (check) =>
          `${check.caseType || ""} - ${check.caseName || ""}`
              )
           .join(", ")
         : "No Criminal Case"}
           </span>
            </div>
          </div>

          <div className="override-form-group">
            <label>
              Override Reason <span>*</span>
            </label>

            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter mandatory reason for overriding this verification decision..."
              maxLength={500}
              rows={5}
              disabled={loading}
              className="override-textarea"
            />

            <div className="override-character-count">
              {reason.length}/500
            </div>
          </div>

        </div>

        <div className="override-modal-footer">
          <button
            type="button"
            className="btn cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn submit"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Overriding..." : "Override Decision"}
          </button>
        </div>

        {loading && (
          <div className="override-loader-overlay">
            <div className="override-loader"></div>
          </div>
        )}
      </div>
    </div>
  );
};


export default OverrideDecisionModal;
